var map = {
	"./en/about.json": [
		20328,
		328
	],
	"./en/blog.json": [
		66893,
		6893
	],
	"./en/footer.json": [
		4141,
		4141
	],
	"./en/heategevus.json": [
		45267,
		5267
	],
	"./en/hoiustamine.json": [
		32189,
		2189
	],
	"./en/kkk.json": [
		54887,
		4887
	],
	"./en/kontakt.json": [
		68951,
		8951
	],
	"./en/kuidasseetootab.json": [
		75373,
		5373
	],
	"./en/landing-page.json": [
		34219,
		4219
	],
	"./en/privacy-policy.json": [
		75176,
		5176
	],
	"./en/sportlandingpage.json": [
		64817,
		4817
	],
	"./en/storage.json": [
		67305,
		7305
	],
	"./en/terms-of-service.json": [
		62982,
		2982
	],
	"./en/tudrukuteohtu.json": [
		92390,
		2390
	],
	"./en/tudrukuteohtukrulli.json": [
		34898,
		4898
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70430;
module.exports = webpackAsyncContext;